<template>
  <div class="ele-body">
    <el-card shadow="never" class="dashboard-card">
      <div class="dashboard-content">
        <div class="dashboard-title">
          <div class="title-icon">
            <i class="el-icon-data-line"></i>
          </div>
          <h2>{{ $t('home.accountOverview') }}</h2>
          <p>{{ $t('home.realtimeFunds') }}</p>
        </div>

        <el-row :gutter="20">
          <el-col :lg="6" :md="6" :sm="6" :xs="12">
            <el-card class="stat-card stat-card-1" shadow="never">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="el-icon-wallet"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-label">{{ $t('home.totalAmount') }}</div>
                  <div class="stat-value">￥{{ form.sum_balance }}</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :lg="6" :md="6" :sm="6" :xs="12">
            <el-card class="stat-card stat-card-2" shadow="never">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="el-icon-_red-packet"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-label">{{ $t('home.availableBalance') }}</div>
                  <div class="stat-value">￥{{ form.sj_balance }}</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :lg="6" :md="6" :sm="6" :xs="12">
            <el-card class="stat-card stat-card-3" shadow="never">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="el-icon-lock"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-label">{{ $t('home.frozenAmount') }}</div>
                  <div class="stat-value">￥{{ form.blockedbalance }}</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :lg="6" :md="6" :sm="6" :xs="12">
            <el-card class="stat-card stat-card-4" shadow="never">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="el-icon-time"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-label">{{ $t('home.unsettledBalance') }}</div>
                  <div class="stat-value">￥{{ form.no_balance }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import setting from '@/config/setting';
export default {
  name: 'Home',
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    /* 获取当前用户信息 */
    getUserInfo() {
      if (setting.userUrl) {
        this.$http.get(setting.userUrl).then((res) => {
          const result = setting.parseUser ? setting.parseUser(res.data) : res.data;
          if (result.code === 0) {
            // 赋予对象值
            this.form = JSON.parse(JSON.stringify(result.data))
          } else {
            this.$message.error(result.msg);
          }
        }).catch((e) => {
          console.error(e);
          this.$message.error(e.message);
        });
      }
    },
  }
}
</script>

<style scoped>
.dashboard-content {
  padding: 20px;
}

/* 标题美化 */
.dashboard-title {
  text-align: center;
  margin-bottom: 30px;
  padding: 30px 20px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}

.title-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
}

.title-icon i {
  font-size: 40px;
  color: white;
}

.dashboard-title h2 {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 10px 0;
  position: relative;
  z-index: 1;
}

.dashboard-title p {
  font-size: 14px;
  color: #909399;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* 数据卡片美化 */
.stat-card {
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .stat-card .el-card__body {
  padding: 25px;
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: white;
  flex-shrink: 0;
}

.stat-info {
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
}

/* 卡片1 - 蓝色 */
.stat-card-1 .stat-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-card-1:hover {
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

/* 卡片2 - 绿色 */
.stat-card-2 .stat-icon {
  background: linear-gradient(135deg, #95de64 0%, #73d13d 100%);
}

.stat-card-2:hover {
  box-shadow: 0 10px 30px rgba(149, 222, 100, 0.3);
}

/* 卡片3 - 橙色 */
.stat-card-3 .stat-icon {
  background: linear-gradient(135deg, #ff9c6e 0%, #ff7875 100%);
}

.stat-card-3:hover {
  box-shadow: 0 10px 30px rgba(255, 156, 110, 0.3);
}

/* 卡片4 - 红色 */
.stat-card-4 .stat-icon {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff4757 100%);
}

.stat-card-4:hover {
  box-shadow: 0 10px 30px rgba(255, 107, 107, 0.3);
}

/* 响应式 */
@media (max-width: 768px) {
  .dashboard-content {
    padding: 10px;
  }
  
  .dashboard-title {
    padding: 20px 15px;
  }
  
  .dashboard-title h2 {
    font-size: 24px;
  }
  
  .stat-value {
    font-size: 20px;
  }
  
  .stat-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
}
</style>

<style>
.el-form-item label {
  font-weight: bold;
  font-size: 16px;
}
</style>
